export class AppSettings {
	copyright: {
		notice: string;
		year: string;
	};

	webApiServer: string;
	idsServer: string;
	idsRoot: string;
	angularRoot: string;
	sgPortalApiServer: string;
	hideStuderLinks: string;
	ssrsReportServerUrl: string;
	idleSessionTimeOut: number;
	environmentName:string;
	siteKey: string;
	reCAPTCHAEnabled: string;
	secureRoutes: string[];
	excludeTokenApps:string;
	hiddenMenuItems: string[];
}
